import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { CountUp } from "@/components/CountUp";

const GOLD_BG = ["#C59B27", "#2C201A", "#8a6d1a", "#4a3a2f", "#a88420"];

function initials(name) {
  return name.split(" ").map((n) => n[0]).slice(0, 2).join("").toUpperCase();
}

export function GuestList({ enabled }) {
  const { data } = useQuery({
    queryKey: ["guests"],
    queryFn: async () => (await api.get("/guests")).data,
    enabled,
    retry: false,
  });
  if (!enabled) return null;
  const guests = data?.guests || [];
  const count = data?.count || 0;

  return (
    <section id="guests" className="bg-espressoDeep grain relative overflow-hidden scroll-mt-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-24 relative z-10">
        <div className="text-center mb-10">
          <p className="text-eyebrow text-goldLight/70">The Guest List</p>
          <h2 className="font-serif text-3xl sm:text-5xl text-white mt-2">
            <CountUp value={count} className="text-goldLight" /> People Are Joining Us
          </h2>
        </div>
        {guests.length === 0 ? (
          <p className="text-center text-white/60">No RSVPs yet — you could be the first 🥂</p>
        ) : (
          <div className="flex flex-wrap justify-center gap-3 sm:gap-4">
            {guests.map((g, i) => (
              <div key={i} className="flex items-center gap-3 bg-white/5 border border-white/10 rounded-full pl-2 pr-5 py-2 backdrop-blur hover:bg-white/10 transition" data-testid={`guest-chip-${i}`}>
                <div className="w-9 h-9 rounded-full grid place-items-center text-white text-xs font-bold" style={{ background: GOLD_BG[i % GOLD_BG.length] }}>
                  {initials(g.name)}
                </div>
                <span className="text-white text-sm font-medium">
                  {g.name.split(" ")[0]}{g.extra > 0 ? ` +${g.extra}` : ""}
                </span>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
}
